<template>
  <div class="wrap-app">
    <the-header/>
    <router-view class="main-container" />
    <the-footer/>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'Layout',
  components: {
    TheHeader,
    TheFooter
  }
}
</script>
